import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { LoadingButtonContent } from "../ui/loading-button-content";
import { FaGoogle } from "react-icons/fa";
import { useToast } from "@/hooks/use-toast";
import { useShopStore } from "@/stores/shopStore";
export function LoginForm() {
    const [emailLoading, setEmailLoading] = useState(false);
    const [googleLoading, setGoogleLoading] = useState(false);
    const { resetShop } = useShopStore();
    const [email, setEmail] = useState("");
    const { signInWithOtp, signInWithOAuth, signInWithPassword } = useAuth();
    const { toast } = useToast();

    const handleEmailLogin = async () => {
        setEmailLoading(true);
        resetShop();
        const { error } = await signInWithOtp(email);

        if (error) {
            toast({
                title: "Failed to send login link",
                description: error.message,
                variant: "destructive",
            });
        } else {
            toast({
                title: "Login link sent",
                description: "Check your email for the login link!",
            });
        }
        setEmailLoading(false);
    };

    const handleGoogleLogin = async () => {
        setGoogleLoading(true);
        resetShop();
        const { error } = await signInWithOAuth("google");
        if (error) {
            toast({
                title: "Failed to login with Google",
                description: error.message,
                variant: "destructive",
            });
        }
        setGoogleLoading(false);
    };

    const handleDemoLogin = async () => {
        const { error } = await signInWithPassword(
            "demo@getoptifi.com",
            "demo"
        );
        if (error) {
            toast({
                title: "Failed to login to demo mode",
                description: error.message,
                variant: "destructive",
            });
        }
    };

    return (
        <Card className="mx-auto max-w-sm">
            <CardHeader>
                <div className="flex justify-center mb-4">
                    <img
                        src="/optifi_logo.png"
                        alt="Logo"
                        className="h-12 w-auto"
                    />
                </div>
                <CardTitle className="text-2xl">Login</CardTitle>
                <CardDescription>
                    Enter your email to receive a secure login link - no
                    password needed
                </CardDescription>
            </CardHeader>
            <CardContent>
                <div className="grid gap-4">
                    <div className="grid gap-2">
                        <Label htmlFor="email">Email</Label>
                        <Input
                            id="email"
                            type="email"
                            placeholder="name@example.com"
                            required
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <Button
                        onClick={handleEmailLogin}
                        className="w-full"
                        disabled={emailLoading || googleLoading}
                    >
                        <LoadingButtonContent loading={emailLoading}>
                            Login with Email
                        </LoadingButtonContent>
                    </Button>

                    <div className="relative">
                        <div className="absolute inset-0 flex items-center">
                            <span className="w-full border-t" />
                        </div>
                        <div className="relative flex justify-center text-xs uppercase">
                            <span className="bg-background px-2 text-muted-foreground">
                                OR
                            </span>
                        </div>
                    </div>

                    <Button
                        variant="outline"
                        className="w-full"
                        onClick={handleGoogleLogin}
                        disabled={emailLoading || googleLoading}
                    >
                        <LoadingButtonContent loading={googleLoading}>
                            <FaGoogle className="h-4 w-4" />
                            Login with Google
                        </LoadingButtonContent>
                    </Button>
                </div>
                {/* <div className="mt-4 text-center text-sm">
                    Don&apos;t have an account?{" "}
                    <Link to="#" className="underline">
                        Sign up
                    </Link>
                </div> */}
                <div className="mt-4 text-center text-sm">
                    Want to try it out?{" "}
                    <Link
                        to="#"
                        onClick={handleDemoLogin}
                        className="underline"
                    >
                        Demo Mode
                    </Link>
                </div>
            </CardContent>
        </Card>
    );
}
